import { Component, OnInit, EventEmitter, Output, Input, ElementRef, ViewChild } from "@angular/core";
import { UserService } from "../services/user.service";
import { PaymentService } from "../services/payment.service";
import * as AppConstant from "../app.string";
import { UtilitiesService } from "../services/utilities.service";
import * as moment from "moment";
import { GoogleTagsService } from "../services/google-tags.service";
import { FacilityDetailsPipe } from "../pipes/facility-details.pipe";
import { HEALTHPACKFILTER } from "../app.const";
import { TranslatePipe } from "../pipes/translate.pipe";
import { TitleCasePipe } from "@angular/common";
import * as _ from "lodash";
import { PackageService } from "../services/package.service";
@Component({
  selector: "app-health-package",
  templateUrl: "./health-package.component.html",
  styleUrls: ["./health-package.component.scss"],
})
export class HealthPackageComponent implements OnInit {
  @Output() close: EventEmitter<any>;
  @Output() next: EventEmitter<any>;
  @Input() pkgdetails: any;
  @Input() selectedPackage: any;
  @Input() packageOpt: any;
  @Input() isWellnessPackageCoupon: boolean = false;
  public packageList: any;
  public searchFacility: any;
  public facilityList: Array<any>;
  public gender: any;
  public genderList: Array<any>;
  public isSelectedGender: string = "A";
  public packs: any;
  public currency_code: string;
  public selectedFacilityId: any;
  public packages: any;
  public searchkey: string = "";
  public hideHealthPackages: boolean;
  public openPkgReq: boolean;
  public selectedPkg: any;
  public userPkgPeferrence: any;
  public reqConfirm: any;
  public showFacility: boolean;
  public selectedGenderValue: any;
  public searchGender: boolean;
  public chosenFacility: any;
  public selectedFacilityFilter: any;
  public loadedContent:boolean=false;
  public facFilterInput = HEALTHPACKFILTER;
  public selectedFacilityList: Array<any>;
  public selectedSpecialityList: Array<any>;
  public selectedGenderList: Array<any>;
  public selectedAgeList: Array<any>;
  // public allPackages: any = [];
  public applicableFilter: Array<any>;
  public isShowExternalFilter: boolean;
  public navOptions: any;
  public filterAsModal:boolean=true;
  public timestamp: any = 1;
  public lastSearchKeyboardEvent:any;
  public flowType: any; 
  public hideHHCNav: any;
  public selectedDirective: any;
  public hideClinicOptFromModeOfService: boolean = false;
  public hideHomeVideoOptFromModeOfService: boolean = false;
  @ViewChild('packageScroll') packageScroll!: ElementRef;
  constructor(
    private user: UserService,
    private paymentService: PaymentService,
    private util: UtilitiesService,
    private gtmService: GoogleTagsService,
    private facilityPipe: FacilityDetailsPipe,
    private translate: TranslatePipe,
    private titleCasePipe: TitleCasePipe,
    private packageService: PackageService
  ) {
    this.close = new EventEmitter<any>();
    this.next = new EventEmitter<any>();

    this.reqConfirm = {
      confirmReq: false,
      status: null,
      data: null,
    };
    this.searchFacility = {
      show: false,
      search: "",
      selected: {},
      prevent: false,
    };
    this.gender = {
      show: false,
      selected: "",
    };
    this.genderList = [
      {
        code: "A",
        desc: "frm_other_opt",
      },
      {
        code: "M",
        desc: "frm_male_opt",
      },
      {
        code: "F",
        desc: "frm_female_opt",
      },
    ];
    this.selectedGenderValue = this.genderList[0].desc;
    const healthPkg = this.packageService.getAllHpValues();
    let allHealthPackages = this.packageService.getAllPackages();
    this.hideHHCNav = this.user.canViewOption('HIDEHHCNAVFROMPACKGE');
    let healthPackages = this.user.getDirectiveByDirectiveGroup("HEALTHPACKAGES");
    let allPackages = this.user.getAllPackageConcepts();
    this.selectedDirective = allHealthPackages[0] ? allHealthPackages[0] : null;
    allPackages = _.orderBy(allPackages,["_displayPriority", "pkgName"],["asc", "asc"]);
    // console.log('allPackages', allPackages);
    this.user.getConfigurationInfo.subscribe(data => {
      this.hideClinicOptFromModeOfService = data['pxAppSettings']['hideClinicOptFromModeOfService'] == 'Y' ? true : false;
      this.hideHomeVideoOptFromModeOfService = data['pxAppSettings']['hideHomeVideoOptFromModeOfService'] == 'Y' ? true : false;
    })
    // setTimeout(()=>{
    this.packageList = allPackages.map((pack) => {
      pack._filterValues = {
        facilities: pack.facilities.map((fac) => fac.facilityId),
        modeOfServices: pack?.packageDtls?.modeOfServices || [],
        packageClassification:
        pack?.packageDtls?.packageClassification || "WELLNESS",
        packageSpeciality: pack?.packageDtls?.packageSpeciality || "UNKNOWN",
        minAge: pack?.filters?.minAge || 0,
        maxAge: pack?.filters?.maxAge || 150,
        gender: pack?.filters?.gender || "A",
      };
      return pack;
    });
    console.info("allPackages>>>>", this.packageList, this.packageOpt);
    let type = this.user.getPackageClassificationType();
    this.flowType = type?.classification;
    this.navOptions = type || { classification: "WELLNESS" };
    console.info("flowType>>>", this.flowType);
    this.mapFilters();
    this.loadedContent = true;
    console.info('navParams', this.packageList, this.navOptions)
    // },400);

    // this.packs = healthPackages[0];
    // this.getFacilityByConcept(this.allPackages);
  }

  private mapFilters() {
    let facilities: any = [].concat.apply([],this.packageList.map((p) => p.facilities || []));
    let uniqueFacilities = _.uniqBy(facilities as any[], (x: any) => x.facilityId);
    let mappedFacilities = uniqueFacilities.map((facility) => {
      return {
        key: facility.facilityId,
        filter: [facility.facilityId],
        label: this.translate.transform(facility.facilityId, "FACNAME"),
        selection: "key",
        selected: false,
      };
    });

    console.info('facilities', facilities, 'uniqueFacilities', uniqueFacilities, 'mappedFacilities', mappedFacilities);
    this.applicableFilter = _.cloneDeep(HEALTHPACKFILTER)
    console.info('HEALTHPACKFILTER', HEALTHPACKFILTER);
    if (mappedFacilities?.length > 0) {
      this.applicableFilter.push({
        type: "facility",
        label: "HEALTHPACK#FILTER#FACILITY",
        enable: true,
        options: mappedFacilities,
        order: 1,
        selection: "compare",
        attribute: "facilities",
      });
    }
    if (this.navOptions?.classification) {
      const classification = this.applicableFilter.find(
        (f) => f.type === "classification"
      );
      if (classification) {
        const option = classification.options.find(
          (o) => o.key === this.navOptions?.classification
        );
        if (option) {
          option.selected = true;
        }
      }
      const packages = this.packageList.filter((pack) => {
        if (this.navOptions?.classification === "PROMO")
          return pack?.packageDtls?.packageClassification === "PROMO";
        else return pack?.packageDtls?.packageClassification !== "PROMO";
      });
      console.info('packages', packages);
      const packageClassification = this.user
        .getPackageClassification()
        .filter((c) => {
          const specialityCount =
            packages?.filter(
              (pack) => pack?.packageDtls?.packageSpeciality === c.code
            )?.length || 0;
          return specialityCount > 0;
        });
      if (packageClassification?.length > 0) {
        let mappedClassification = packageClassification.map(
          (classification) => {
            return {
              key: classification.code,
              icon: classification.packageImageIndex,
              label:
                classification.code === "PROMO"
                  ? `PROMO#SEPCIALITY#${classification.code}`
                  : `WELLNESS#SEPCIALITY#${classification.code}`,
              filter: [classification.code],
              selection: "key",
              selected: this.navOptions?.speciality === classification.code,
            };
          }
        );
        const allClassifications = packageClassification.map((c) => c.code);
        allClassifications.push("UNKNOWN");
        mappedClassification.unshift({
          key: "UNKNOWN",
          icon:
            this.navOptions?.classification !== "PROMO"
              ? "./assets/icon/wellnesspromo/all_wellness.svg"
              : "./assets/icon/wellnesspromo/all_promo.svg",
          label: `PROMO#WELLNESS#SEPCIALITY#ALL`,
          filter: allClassifications,
          selection: "key",
          selected: !this.navOptions?.speciality,
        });
        console.info('allClassifications', allClassifications);
        this.applicableFilter.push({
          type: "speciality",
          label: "HEALTHPACK#FILTER#SPECIALITY",
          enable: true,
          hideInModal: true,
          showInFilterRow: true,
          options: mappedClassification,
          order: 0,
          selection: "in",
          attribute: "packageSpeciality",
        });
      }
    }
    this.applicableFilter = this.applicableFilter.sort(
      (a, b) => a["order"] - b["order"]
    );
  }

  ngOnInit(): void {
    if (this.pkgdetails) {
      this.checkOrderDetails();
      // this.openPkgReq =true;
    } else if (this.selectedPackage) {
      this.hideHealthPackages = true;
      this.selectedPkg = this.selectedPackage;
      if (Array.isArray(this.selectedPkg["detail"]) && this.selectedPkg["detail"].length ) {
        const obj = {
          value: +this.getDiscountChargeByFacility(this.selectedPkg),
          package_name: this.selectedPkg["name"][0]["name"],
        };
        this.gtmService.pushGTMEvent("Health Packages", "package_details", obj);
      }

      console.info('selectedPackage', this.selectedPackage, 'packageList', this.packageList);
      let selectedPkgObj = this.packageList.find((pack) => pack.code === this.selectedPackage.code);
      if(selectedPkgObj) {
        this.selectedDirective = this.packageList.find((pack) => pack.code === this.selectedPackage.code);
        this.packageService.setValue('selectedDirective', this.selectedDirective);
        this.getSelectedPackageDetail(selectedPkgObj);
      }
    } else this.gtmService.pushGTMEvent("Health Packages", "choose_package");
    this.currency_code = this.user.getCurrency();
  }

  public closeModal() {
    this.close.emit("CLOSE");
  }

  public selectFacility(value: any) {
    this.selectedFacilityId = value.facilityId;
    this.getFiltered(this.packageList);
    if (value) {
      this.searchFacility = {
        show: false,
        search: "",
        selected: value,
      };
    }
  }

  public closeFacility() {
    this.searchFacility = {
      show: false,
    };
  }

  public selectGender(ev) {
    this.isSelectedGender = ev.code;
    this.selectedGenderValue = ev.desc;
    this.searchGender = false;
    let packsArray = JSON.parse(
      this.user.getStorage(AppConstant.HEALTHPKG_LIST)
    );
    this.getFiltered(this.packageList);
  }

  getSubTitle(names) {
    for (let l in names) {
      if (names[l].locale == this.user.currentLanguage) {
        return names[l].description;
      } else {
        return names[l].description;
      }
    }
  }

  getTitle(names) {
    if (names.length == 0) {
      return "";
    } else {
      let t = names.find((name) => {
        return name.locale == this.user.currentLanguage;
      });
      if (t) {
        return t.name;
      } else {
        return names[0].name;
      }
    }
  }

  getFiltered(data?: any) {
    let arrayToFilter = data;

    //Filter by gender
    // arrayToFilter = arrayToFilter.filter( item => {
    //   return item.filters.gender == this.isSelectedGender
    // })
    // console.log("After filtering Gender", arrayToFilter)

    //Filter by facility ID
    // arrayToFilter = arrayToFilter.filter((item) => {
    //   if(item.facilities.filter((i)=>{
    //      if(i.facilityId==this.selectedFacilityId){
    //        return i
    //      }
    //   }).length>0){
    //     return item;
    //   }
    // });
    // console.log("After filtering Facility", arrayToFilter)

    //Filter by search keyword
    if (this.searchkey) {
      arrayToFilter = arrayToFilter.filter((item) => {
        // console.log("item", item.name , this.getTitle(item.name))
        return (
          this.getTitle(item.name)
            .toLowerCase()
            .indexOf(this.searchkey.toLowerCase()) > -1
        );
      });
    }
    this.packs["concepts"] = arrayToFilter;
    // console.log("After final filtering", this.packs);
  }

  protected onchange(evt) {
    this.searchkey = evt.srcElement.value;
     this.lastSearchKeyboardEvent=evt;
    let packsArray = JSON.parse(
      this.user.getStorage(AppConstant.HEALTHPKG_LIST)
    );
    this.getFiltered(this.packageList);
  }

  public getPackageDetail(data) {
    // console.log("this.checkExpire(data.facilities)", this.checkExpire(data.facilities))
    if (!this.checkExpire(data.facilities)) return;
    else {
      this.hideHealthPackages = true;
      this.selectedPkg = data;
      this.selectedPkg["selectedFacilityId"] = this.selectedFacilityId;
      if (Array.isArray(data["detail"]) && data["detail"].length) {
        const obj = {
          value: +this.getDiscountChargeByFacility(data),
          package_name: data["name"][0]["name"],
        };
        this.gtmService.pushGTMEvent("Health Packages", "package_details", obj);
      }
    }
  }

  public closePkgDetail() {
    this.hideHealthPackages = false;
    this.openPkgReq = false;
  }

  public openConfirm(ev) {
    this.hideHealthPackages = false;
    this.openPkgReq = true;
    this.userPkgPeferrence = ev;
    this.userPkgPeferrence["notify"] = this.packs.facilities[0]["controls"];
    this.gtmService.pushGTMEvent(
      "Health Packages",
      "package_request_confirmation"
    );
  }

  private checkOrderDetails() {
    // console.log("hlthpkg checkOrderDetails", this.pkgdetails);
    let orderData = atob(this.pkgdetails);
    let arr = orderData.split("&");
    let params = {};
    for (var i = 0; i < arr.length; i++) {
      var pair = arr[i].split("=");
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    this.paymentService
      .getTransactionDetail(params["orderid"])
      .subscribe((data) => {
        // console.log("getTransactionDetail", data, params["h"]);
        if (data.status == "S") {
          // this.userPkgPeferrence = params['d']
          this.userPkgPeferrence = JSON.parse(
            this.user.getStorage(AppConstant.HEALTHPKG_REQ)
          );
          this.openPkgReq = true;
          this.reqConfirm = {
            confirmReq: true,
            status: data.status,
            data: data,
          };
        } else if (
          data.status == "R" ||
          data.status == "F" ||
          data.status == "P"
        ) {
          this.userPkgPeferrence = JSON.parse(
            this.user.getStorage(AppConstant.HEALTHPKG_REQ)
          );
          this.openPkgReq = true;
          this.reqConfirm = {
            confirmReq: true,
            status: data.status,
            data: data,
          };
        }
      });
  }

  public toggleSelection(groupType, optionKey) {
    // console.log('toggleSelection', groupType, optionKey, this.flowType);
    if(this.lastSearchKeyboardEvent?.target?.value){
      this.lastSearchKeyboardEvent.target.value='';
      this.searchkey = ''
    }
    const group = this.applicableFilter.find(g => g.type === groupType);
    if (group) {
      group.options.forEach(option => {
        option.selected = option.key === optionKey;
      })
    }
    this.timestamp = moment().valueOf()
    this.unselectAllFilters()

    setTimeout(() => {
      if (this.packageScroll?.nativeElement) {
        this.packageScroll.nativeElement.scrollTop = 0;
      }
    }, 0);
  }

  public unselectAllFilters() {
  const filterGroups = ['AGE', 'GENDER'];
  this.applicableFilter = this.applicableFilter.map(filter => ({
    ...filter,
    show: filterGroups.includes(filter.type.toUpperCase())
  }));
  this.applicableFilter.forEach(filterGroup => {
    if (filterGroup.show && filterGroup.options) {
      if (filterGroup.options.some(option => option.selected)) {
        filterGroup.options.forEach(option => {
          option.selected = false;
        });
      }
    }
  });
}

  // public getFacilityByConcept(concepts) {
  //   this.facilityList = this.util.getFacilityByConcept(concepts);
  //   this.facilityList.map((i) => {
  //     i.key = i["facilityId"];
  //     i.value = this.facilityPipe.transform(i["facilityId"], "facilityName");
  //   });
  //   this.selectFacility(this.facilityList[0]);
  // }

  public checkExpire(facilities) {
    let facility;
    facility = facilities.find((fac) => {
      return fac.facilityId == this.selectedFacilityId;
    });
    if (facility) {
      if (facility["expires"]) return this.checkTime(facility["expires"]);
    } else {
      facility = facilities[0];
      if (facility["expires"]) return this.checkTime(facility["expires"]);
    }
  }

  public checkTime(expire) {
    if (this.user.getMoment().isBefore(expire)) {
      return true;
    } else {
      return false;
    }
  }

  public getChargeByFacility(pack) {
    let charge: any;
    pack.facilities.find((item) => {
      if (item.facilityId == this.selectedFacilityId) {
        this.chosenFacility = item;
      }
    });
    if (this.chosenFacility) {
      charge = this.chosenFacility.controls.charge;
    } else {
      charge = pack?.facilities[0]?.controls.charge;
    }
    // console.log('getChargeByFacility', charge)
    return charge;
  }
  public getDiscountChargeByFacility(pack) {
    let discountCharge: any;
    pack.facilities.find((item) => {
      if (item.facilityId == this.selectedFacilityId) {
        this.chosenFacility = item;
      }
    });
    if (this.chosenFacility) {
      discountCharge = this.chosenFacility.controls.discountCharge;
    } else {
      discountCharge = pack?.facilities[0]?.controls.charge;
    }

    // console.log('getDiscountChargeByFacility', discountCharge);
    return discountCharge;
  }

  public getPackageImg(detail) {
    let t = detail.find((name) => {
      return name.locale == this.user.currentLanguage;
    });
    if (t) {
      return t.imageURL;
    } else {
      return detail[0].imageURL;
    }
  }

  public filterPackages(event) {
    // console.log("===== filterPackages", event);
    if (event?.allFilters) this.applicableFilter = event.allFilters;
    if (this.isShowExternalFilter) {
      this.isShowExternalFilter = false;
    }
  }

  public openFilterModal(ev) {
    this.isShowExternalFilter = true;
  }

  public checkAction(event) {
    // console.log("checkAction =====>", event);
    if (event == "CLOSE") this.closeModal();
  }

  public getSelectedPackageDetail(data) {
    console.log("getSelectedPackageDetail", data);
    if (!this.checkExpire(data.facilities)) return;
    else {
      // this.hideHealthPackages = true;
      this.selectedPkg = data;
      this.packageService.setValue('flowType', 'HEALTHPKG');
      this.packageService.setValue('selectedDirective', this.selectedDirective);
      this.packageService.setValue('selectedPackage', data);
      // this.selectedPkg["selectedFacilityId"] = this.selectedFacilityId;
      if (Array.isArray(data["detail"]) && data["detail"].length) {
        const obj = {
          value: +this.getDiscountChargeByFacility(data),
          package_name: data["name"][0]["name"],
        };
        this.gtmService.pushGTMEvent("Health Packages", "package_details", obj);
      }
      this.next.emit({data: this.selectedPkg,state: "CHOOSE_PACKAGE",key: "selectedPkg",});
    }
  }
}
